import { useContext, useEffect, useRef, useState } from 'react';
import { apiContext } from '../../../contexts/apiContext';
import ViewContext from '../../../contexts/viewContext';
import { CollectiveEditionViewProps } from './types/CollectiveEditionViewProps';
import { notifyError } from '../../../components/snackbar/snackbar';
import Spinner from '../../../components/spinner/spinner';
import { ClassNameSpinner } from '../../../components/spinner/types/spinnerProps';
import { checkAssignStatus, checkCollectiveProgress, createCollectiveProgress, populateCollectiveCardForm, saveCollectiveCard } from '../../../services/registrationCardService/registrationCardService';
import { ObjectType, PatternType } from '../../../contexts/types/card';
import KrFormContext, { KrEndangeredAreaFormTypes, KrLandslideFormTypes, defaultKrForm, krFormTypes } from '../../../contexts/krFormContext';
import { Dictionary, getAdditionalDictionaries, getDictionariesFromLayers, getDictionaryForCodedValues } from '../../../helpers/dictionariesFromLayers';
import { prepareAllFields } from '../../../helpers/form';
import CollectiveLandslideForm from './collectiveLandslideForm';
import { CollectiveActionType } from './components/types/collectiveActionType';
import CollectiveEndangeredAreaForm from './collectiveEndangeredAreaForm';
import ButtonField from '../../../components/buttonField/buttonField';
import { classNameBtn } from '../../../components/shared/button/types/buttonProps';
import { toSave, validate } from '../../../helpers/collective/save';
import ProgressBarField from '../../../components/progressBarField/progressBarField';
import { ProgressBarFieldProps } from '../../../components/progressBarField/types/progressBarFieldProps';
import ConfirmModal from '../../../components/modalWindow/confirmModal';
import Modal from '../../../components/modalWindow/modal';
import { ReactComponent as EditIcon } from "../../../icons/edit.svg";
import './collectiveEditionView.scss';
import { getCodedValuesDictionaries, getDictionaries, getTask, setTask } from '../../../database/indexedDbReadWrite';

const CollectiveEditionView = (props: CollectiveEditionViewProps) => {
    const api = useContext(apiContext);
    const { setViewType, viewTypes } = useContext(ViewContext);
    const [krForm, setkrForm] = useState<krFormTypes>(defaultKrForm());
    const [collectiveActions, setCollectiveActions] = useState<{ [key: string]: CollectiveActionType | null }>({});
    const [loading, setLoading] = useState<boolean>(true);
    const [saveConfirmation, setSaveConfirmation] = useState<boolean>(false);
    const [decisionConfirmation, setDecisionConfirmation] = useState<boolean>(false);
    const [reassignDialog, setReassignDialog] = useState<boolean>(false);
    const [reassignQuestion, setReassignQuestion] = useState<any>({ text: '', ids: [] });
    const [validationConfirmation, setValidationConfirm] = useState<boolean>(false);
    const [forms, setForms] = useState<any>({ forms: [] });
    const objectType = props.rows[0].attributes.RODZAJ_OBIEKTU;

    let fillDateProp: number = 0;

    const [fillDate, setFillDate] = useState<number>(fillDateProp);

    const [saveMode, setSaveMode] = useState<boolean>(false);
    const [progress, setProgress] = useState<boolean>(false);
    const [summary, setSummary] = useState<any>(null);
    const [uploadPercent, setUploadPercent] = useState<number>(0);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [local, setLocal] = useState<boolean>(props.local as boolean);

    const [reload, setReload] = useState<boolean>(true);

    let progressGid = useRef<string>('');
    let onePercentage = useRef<number>(1);

    useEffect(() => {
        const firstRow = props.rows[0];
        const rodzajObiektu = firstRow.attributes.RODZAJ_OBIEKTU;
        const globalIds = props.rows.map((r: any) => r.attributes["GLOBALID"]);
        const configKey = rodzajObiektu === ObjectType.KRO ? 'landslide' : 'endangeredArea';

        setLoading(true);
        if (props.local) {
            const PromiseArray: Promise<any>[] = [];
            for (let i = 0; i < globalIds.length; i++) {
                PromiseArray.push(getTask(globalIds[i] as string));
            }
            if (PromiseArray.length > 0) {
                Promise.all(PromiseArray).then((response) => {
                    let forms: any[] = [];
                    response.forEach((resp) => {
                        if (resp.elementParams.card.landslideAttributes) {
                            let form = resp.elementParams.card as KrLandslideFormTypes;
                            forms.push(form);
                        }
                        if (resp.elementParams.card.endangeredAreaAttributes) {
                            let form = resp.elementParams.card as KrEndangeredAreaFormTypes;
                            forms.push(form);
                        }
                    })
                    if (forms.length > 0) {
                        let form: any = getStartForm(rodzajObiektu);
                        form.dicts = forms[0].dicts;
                        getDictionaries(configKey).then((response) => {
                            form.dictionaries = response;
                            getCodedValuesDictionaries().then((codedValues) => {
                                form.dictionariesCodedValues = codedValues;
                                prepareAllFields(rodzajObiektu, PatternType.P2020, form);
                                setForms({ forms: forms });
                                rodzajObiektu === ObjectType.KRO ? form.landslideGminy = prepareGminy(forms) : form.endangeredAreaGminy = prepareGminy(forms);
                                setkrForm(form);
                                setLoading(false);
                            });
                        });
                    }
                });
            }
        }
        else {
            populateCollectiveCardForm(rodzajObiektu, globalIds, api.apiUrl + api.apiVersion)
                .then((response: any) => {
                    var Dictionaries: Dictionary = {};
                    let form: any = getStartForm(rodzajObiektu);
                    form.dicts = response?.data?.dicts;

                    var definitions = api.featureServices.additionalDictionaries[configKey].filter(d => d[4] === '1');
                    getAdditionalDictionaries(api.featureServices.additionalDictionariesBaseUrl, definitions, Dictionaries, undefined, getMiejscowosciGminyWhere(response.data.forms)).then(() => {
                        form.dictionaries = Dictionaries;

                        var authorDictId = api.featureServices.dictionariesForCodedValues.find(item => item[0] === "AUTORZY");
                        if (authorDictId) {
                            getDictionaryForCodedValues(api.featureServices.dictionariesForEditingBaseUrl + authorDictId[1])
                            .then((res) => { 
                                var dictId: number = +authorDictId![1];
                                form.dictionariesCodedValues = getDictionariesFromLayers(res, [dictId]);
                                prepareAllFields(rodzajObiektu, PatternType.P2020, form);
                                setForms(response?.data ? response.data : { forms: [] });
                                rodzajObiektu === ObjectType.KRO ? form.landslideGminy = prepareGminy(response.data.forms) : form.endangeredAreaGminy = prepareGminy(response.data.forms);
                                setkrForm(form);
                                setLoading(false);
                            })
                            .catch((error) => {
                                console.log("1", error)
                                populateCollectiveFormError();
                            });
                        } 
                    }).catch((error) => {
                        console.log("2", error)
                        populateCollectiveFormError();
                    });
                })
                .catch((error) => {
                    console.log("3", error)
                    populateCollectiveFormError();
                });
            return () => { }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [api.apiUrl, api.apiVersion, api.featureServices.additionalDictionaries, props.rows, setViewType, viewTypes.TaskList]);

    const populateCollectiveFormError = () => {
        notifyError({ message: "Próba pobrania danych do zbiorczej edycji zakończona niepowodzeniem" });
        setViewType(viewTypes.TaskList);
    }

    const getCommonGminyIds = (forms: any[]) => {
        var gminyIdsArrays = forms.map(item => {
            var gminy = (objectType === ObjectType.KRO) ? (item as KrLandslideFormTypes).landslideGminy : (item as KrEndangeredAreaFormTypes).endangeredAreaGminy;
            return gminy ? gminy?.map(elem => {
                return elem.gminA_ID
            })! : undefined;
        })
        if (gminyIdsArrays.length > 1) {
            if (gminyIdsArrays.some(item => item?.length === 0 || item === undefined)) return undefined;
            const countMap = new Map();
            const totalArrays = gminyIdsArrays.length;

            // Count occurrences of each number across all arrays
            gminyIdsArrays.forEach(array => {
                array?.forEach(number => {
                    countMap.set(number, (countMap.get(number) || 0) + 1);
                });
            });

            // Filter numbers that appear in all arrays
            const result = Array.from(countMap.entries())
                .filter(([number, count]) => count === totalArrays)
                .map(([number]) => number);
            return result;
        }
        else {
            return gminyIdsArrays[0];
        }
    }

    const getMiejscowosciGminyWhere = (forms: any[]) => {
        var commonGminyIds = getCommonGminyIds(forms);
        if (commonGminyIds && commonGminyIds?.length > 0) return `GMI_ID IN(${commonGminyIds.join()})`
        else return undefined;
    }

    const prepareGminy = (forms: any[]) => {
        var commonGminyIds = getCommonGminyIds(forms);
        if (commonGminyIds && commonGminyIds?.length > 0) {
            return objectType === ObjectType.KRO ? forms[0].landslideGminy.filter((item: any) => commonGminyIds?.includes(item.gminA_ID))
                : forms[0].endangeredAreaGminy.filter((item: any) => commonGminyIds?.includes(item.gminA_ID));
        }
        else return undefined;
    }

    const getStartForm = (rodzajObiektu: ObjectType) => {
        let form: any = {};
        if (rodzajObiektu === ObjectType.KRO) {
            form = { landslideAttributes: {}, rocks: [], rockDeposits: [], rocksDepositAzimuths: [], koluvia: [], elaborators: [], developments: [], documents: [], publications: [], movementCause: [], landslideGminy: [] };
        } else {
            form = { endangeredAreaAttributes: {}, designationCriteria: [], elaborators: [], endangeredAreaGminy: [] };
        }
        return form;
    }

    const setActionType = (keyName: string, actionType: CollectiveActionType | null) => {
        let newActions = JSON.parse(JSON.stringify(collectiveActions));
        newActions[keyName] = actionType;
        setCollectiveActions(newActions);
    }

    const reloadMiejscDict = (existingForms: any, currentForms: any[]) => {
        if (JSON.stringify(getCommonGminyIds(existingForms.forms)?.sort()) !== JSON.stringify(getCommonGminyIds(currentForms)?.sort())) {
            var Dictionaries: Dictionary = {};
            var definitions = api.featureServices.additionalDictionaries[objectType === ObjectType.KRO ? 'landslide' : 'endangeredArea'].filter(d => d[4] === '1');
            setLoading(true);
            getAdditionalDictionaries(api.featureServices.additionalDictionariesBaseUrl, definitions, Dictionaries, undefined, getMiejscowosciGminyWhere(currentForms)).then(() => {
                krForm.dictionaries = Dictionaries;
                objectType === ObjectType.KRO ? (krForm as KrLandslideFormTypes).landslideGminy = prepareGminy(currentForms) : (krForm as KrEndangeredAreaFormTypes).endangeredAreaGminy = prepareGminy(currentForms);
                setkrForm(krForm);
                setLoading(false);
            }).catch(() => {
                notifyError({ message: "Próba pobrania danych do zbiorczej edycji zakończona niepowodzeniem" });
                setViewType(viewTypes.TaskList);
            });
        }
    }

    const handleDeleteIds = (ids: any) => {
        const newForms = forms?.forms?.filter((f: any) => {
            if (objectType === ObjectType.KRO) {
                return !ids.includes(f.landslideAttributes.numeR_IDENTYFIKACYJNY);
            } else {
                return !ids.includes(f.endangeredAreaAttributes.numeR_IDENTYFIKACYJNY);
            }
        });

        if (newForms === null || newForms === undefined || newForms.length === 0) {
            cancel();
        } else {
            reloadMiejscDict(forms, newForms);
            setForms({ ...forms, forms: newForms });
        }
    }

    const save = () => {
        const isValid = validate(objectType, collectiveActions, krForm);
        if (isValid) {
            setSaveConfirmation(true);
        } else {
            setValidationConfirm(true);
        }
    }

    const getProgressBarFieldProps = (currentPercentage: number): ProgressBarFieldProps => {
        return {
            progressBarInfoProps: {
                currentPercentage: currentPercentage,
                fileName: '',
                uploadProcessStatus: 'Zapis kart'
            },
            progressBarProps: {
                currentPercentage: currentPercentage
            }
        }
    }

    const saveClose = () => {
        setSaveConfirmation(false);
        setValidationConfirm(false);
    }

    async function saveTasksLocal(modifiedForms: KrLandslideFormTypes[] | KrEndangeredAreaFormTypes[]) {
        let list: string[] = [];
        for (let i = 0; i < modifiedForms.length; i++) {
            let result = new Promise<string>((resolve, reject) => {
                setTask(modifiedForms[i], undefined, undefined, true, undefined, true).then(() => {
                    const currentPercentage = 10 + i * onePercentage.current;
                    setUploadPercent(currentPercentage);
                    resolve("");
                }).catch((error: any) => {
                    reject(error);
                    console.log("error when saving", error);
                })
            });
            let res = await result;
            if (res !== "") {
                list.push(res);
            }

        }
        return list;
    }

    const saveConfirm = () => {
        setSaveConfirmation(false);
        setValidationConfirm(false);
        if (!forms?.forms || forms.forms.length < 1) return;

        setSaveMode(true);
        const allCounts = forms.forms.length;
        onePercentage.current = Math.floor(80 / allCounts);

        if (uploadPercent !== 0) setUploadPercent(0);
        setProgress(true);
        const modifiedForms = toSave(objectType, collectiveActions, krForm, forms.forms);
        if (props.local) {
            setUploadPercent(10);
            saveTasksLocal(modifiedForms).then((response) => {
                if (response.length > 0) {
                    onSaveFailed({ message: response.toString() });
                }
                else {
                    setUploadPercent(100);
                    setProgress(false);
                    setSummary({
                        info: `Zaktualizowano ${modifiedForms.length} kart`,
                        errors: [],
                        success: true
                    });
                    setForms({ ...forms, forms: modifiedForms });
                }
            }).catch((error) => {
                console.log("error when saving", error);
                onSaveFailed(error);
            });
        }
        else {
            const url = api.apiUrl + api.apiVersion;
            createCollectiveProgress(url)
                .then((pGid: any) => {
                    progressGid.current = pGid as string;
                    setUploadPercent(10);
                    saveCollectiveCard(url, objectType, modifiedForms, progressGid.current)
                        .then((res: any) => {
                            setUploadPercent(100);
                            setProgress(false);
                            setSummary({
                                info: res.info,
                                errors: res.errors,
                                success: res.success
                            });
                            if (res.success) {
                                setForms({ ...forms, forms: res.forms ? res.forms : [] });
                            }
                        })
                        .catch((error: any) => {
                            onSaveFailed(error);
                        });
                })
                .catch((error: any) => {
                    onSaveFailed(error);
                });
        }
    }

    const onSaveFailed = (error: any) => {
        setProgress(false);
        setSummary({
            info: "Nieoczekiwany wyjątek",
            errors: [error?.message],
            success: false
        });
    }

    const cancel = () => {
        setViewType(viewTypes.TaskList);
    }

    const closeModal = () => {
        if (summary !== null) {
            setSaveMode(false);
            setDecisionConfirmation(true);
        }
    }

    const decisionConfirm = () => {
        setDecisionConfirmation(false);
        if (summary !== null && summary.success === true) {
            let form: any = getStartForm(objectType);
            form.dictionaries = { ...krForm.dictionaries };
            form.dicts = { ...krForm.dicts };
            objectType === ObjectType.KRO ? form.landslideGminy = prepareGminy(forms.forms) : form.endangeredAreaGminy = prepareGminy(forms.forms);
            setkrForm(form);
            setCollectiveActions({});
            setReload(false);
        }
        setSummary(null);
    }

    useEffect(() => {
        if (reload === false) {
            setReload(true);
        }
    }, [reload])

    const reassignConfirm = () => {
        handleDeleteIds(reassignQuestion.ids);
        setReassignQuestion({ text: '', ids: [] });
        setReassignDialog(false);
    }

    //Assign status card check
    useEffect(() => {
        if (!props.local) {
            let intervalId = setInterval(() => {
                const stopDisplay = () => {
                    return saveMode === true || loading === true || saveConfirmation === true
                        || decisionConfirmation === true || reassignDialog === true;
                }
                if (stopDisplay()) {
                    return;
                }
                const gids = forms?.forms?.map((f: any) => {
                    return f.waitingRoomGlobalId;
                });
                if (gids && gids.length > 0) {
                    checkAssignStatus(gids, api.apiUrl + api.apiVersion)
                        .then((res: any) => {
                            const ids = res.data;
                            if (stopDisplay() === false && ids && ids.length > 0) {
                                const question = `${objectType} o numerach ${ids.join(", ")} zostały przypisane do innego edytora. Co chcesz zrobić?`;
                                setReassignQuestion({ text: question, ids: ids });
                                setReassignDialog(true);
                            }
                        })
                        .catch((error: any) => { });
                }
            }, 60000);
            return (() => {
                clearInterval(intervalId)
            })
        }
    }, [api.apiUrl, api.apiVersion, decisionConfirmation, forms?.forms, loading, objectType, saveMode, reassignDialog, saveConfirmation, props.local])

    useEffect(() => {
        if (!props.local) {
            if (!progress) return;
            let intervalId = setInterval(() => {
                if (progressGid.current) {
                    checkCollectiveProgress(progressGid.current, api.apiUrl + api.apiVersion)
                        .then((res: any) => {
                            const currentItem = Number(res.data);
                            const currentPercentage = 10 + currentItem * onePercentage.current;
                            setUploadPercent(currentPercentage);
                        })
                        .catch((error: any) => { });
                }
            }, 30000);
            return (() => {
                clearInterval(intervalId)
            })
        }
    }, [api.apiUrl, api.apiVersion, progress, props.local])

    return (
        <KrFormContext.Provider value={{ krForm, setkrForm, local, fillDate, setFillDate }}>
            <div className="collective-titleBar">
                <h3>Formularz zbiorczej edycji</h3>
                <div className="collective-save-btns">
                    <ButtonField
                        BtnProps={{
                            onClick: save,
                            className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium`,
                            disabled: !forms?.forms || forms.forms.length < 1
                        }}
                        placeHolder="Zapisz zmiany w formularzach"
                    />
                    <ButtonField
                        BtnProps={{
                            onClick: cancel,
                            className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium`
                        }}
                        placeHolder="Anuluj"
                    />
                </div>
            </div>
            <div className="collectiveEditFormView">
                {loading && <Spinner spinnerClass={ClassNameSpinner.BigGrid} />}
                {!loading && forms?.forms !== null && reload &&
                    <>
                        {objectType === ObjectType.KRO && <CollectiveLandslideForm
                            actions={collectiveActions}
                            setActions={setActionType}
                            onDelete={handleDeleteIds}
                            forms={forms?.forms}
                        />}
                        {objectType === ObjectType.KRTZ && <CollectiveEndangeredAreaForm
                            actions={collectiveActions}
                            setActions={setActionType}
                            onDelete={handleDeleteIds}
                            forms={forms?.forms}
                        />}
                    </>}
            </div>
            {saveConfirmation && <ConfirmModal width={"660px"} height={"auto"}
                confirmTitle={"Tak"}
                onConfirm={saveConfirm}
                cancelTitle={"Nie"}
                onCancel={saveClose}
                question={"Dane zostaną wprowadzone do wybranych kart rejestracyjnych. Czy chcesz kontynuować?"}
            />}
            {decisionConfirmation && <ConfirmModal width={"660px"} height={"auto"}
                confirmTitle={"Zostań w formularzu edycji zbiorczej"}
                onConfirm={decisionConfirm}
                cancelTitle={"Zamknij formularz"}
                onCancel={cancel}
                question={summary && summary.success === false ? "Dane nie zostały zapisane. Co chcesz zrobić?" : "Dane zostały zapisane. Co chcesz zrobić?"}
            />}
            {reassignDialog && <ConfirmModal width={"700px"} height={"auto"}
                confirmTitle={"Usuń karty z edycji zbiorczej i kontynuuj"}
                onConfirm={reassignConfirm}
                cancelTitle={"Zakończ i zamknij formularz bez zapisania zmian"}
                onCancel={cancel}
                question={<div>{reassignQuestion.text}</div>}
            />}
            {validationConfirmation && <ConfirmModal width={"660px"} height={"auto"}
                confirmTitle={"Tak, zapisz"}
                onConfirm={saveConfirm}
                cancelTitle={"Nie, wróć do formularza"}
                onCancel={saveClose}
                question={"Istnieją pola uzupełnione wartościami, dla których nie wybrano żadnej opcji zapisu. Czy chcesz kontynuować?"}
            />}
            {saveMode && <Modal
                title={"Zapis edycji zbiorczej"}
                titleIcon={EditIcon}
                width='520px'
                height='410px'
                actionBtns={[
                    <ButtonField
                        key={1}
                        BtnProps={{
                            onClick: closeModal,
                            className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium`,
                            disabled: summary === null
                        }}
                        placeHolder="Zamknij"
                    />
                ]}
                onClose={closeModal}>
                {progress && <ProgressBarField {...getProgressBarFieldProps(uploadPercent)} />}
                {summary !== null && <div className="body-txt-large collective-summary">
                    <div>Podsumowanie:</div>
                    <div>{summary?.info}</div>
                    {summary?.errors && summary?.errors?.length > 0 && <div className="body-txt-large collective-summary collective-summary-error">
                        <div>Błędy operacji:</div>
                        {summary.errors.map((e: any, idx: any) => {
                            return <div key={idx}>{e}</div>
                        })}
                    </div>}
                </div>}
            </Modal>}
        </KrFormContext.Provider>
    )
}

export default CollectiveEditionView;